import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import * as API from "./../Endpoints/Endpoints";

const NetworkTable = () => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = 5;

    const navigate = useNavigate();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        axios.get(API.GET_NETWORK_API)
        .then((res) => {
            console.log(res.data); // Check the structure here
            setSubscriptions(res.data);
        });      
    };

    const DeleteSubscription = (netid) => {
        if (window.confirm("Are you sure you want to delete this subscription?")) {
            axios({
                url: API.DELETE_NETWORK_API(netid), // Replace with your actual DELETE API endpoint
                method: 'DELETE',
            }).then((res) => {
                alert("Deleted subscription successfully");
                getData();
            }).catch((err) => {
                alert("Error: " + err);
            });
        }
    };

    const ViewSubscription = (netid) => {
        navigate(`/viewnetwork/${netid}`); // Navigate to view subscription page
    };

    const UpdateSubscription = (netid) => {
        navigate(`/updatenetwork/${netid}`); // Navigate to edit subscription page
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;

    const filteredSubscriptions = subscriptions.filter(subscription =>
        (subscription.subname && subscription.subname.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (subscription.subtype && subscription.subtype.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const currentPageData = filteredSubscriptions.slice(offset, offset + itemsPerPage);

    const highlightText = (text, term) => {
        if (!term) return text;
        const parts = text.split(new RegExp(`(${term})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === term.toLowerCase() ? (
                <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span>
            ) : part
        );
    };

    return (
        <div className='bg-[#B5B5B5] h-[auto] pb-20 pt-10'>
            <div className='p-4'>
                <button className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-5 rounded-full flex justify-center items-center mx-auto" onClick={() => navigate("/addnetwork")}>
                    Add Subscription
                </button>
            </div>

            <div className="max-w-4xl mx-auto pt-4">
                <input
                    type="text"
                    placeholder="Search subscriptions..."
                    className="w-full px-3 py-2 mb-4 text-gray-700 border rounded-lg focus:outline-none focus:border-[#e64a32]"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className="max-w-4xl mx-auto pt-[30px]">
                <div className="flex flex-col">
                    <div className="overflow-x-auto shadow-md sm:rounded-lg">
                        <div className="inline-block min-w-full align-middle">
                            <div className="overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                                    <thead className="bg-white dark:bg-white font-bold text-black">
                                        <tr>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                ID
                                            </th>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Subscription Name
                                            </th>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Subscription Type
                                            </th>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Level 1
                                            </th>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Level 2
                                            </th>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Level 3
                                            </th>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Level 4
                                            </th>
                                            <th className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                                        {currentPageData.map((subscription, index) => (
                                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    {highlightText(subscription.netid, searchTerm)}
                                                </td>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    {highlightText(subscription.subname, searchTerm)}
                                                </td>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    {highlightText(subscription.subtype, searchTerm)}
                                                </td>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    {highlightText(subscription.level1, searchTerm)}
                                                </td>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    {highlightText(subscription.level2, searchTerm)}
                                                </td>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    {highlightText(subscription.level3, searchTerm)}
                                                </td>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    {highlightText(subscription.level4, searchTerm)}
                                                </td>
                                                <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                    <div className="inline pr-[3px]">
                                                        <button
                                                            className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-5 rounded-full"
                                                            onClick={() => ViewSubscription(subscription.netid)}
                                                        >
                                                            View
                                                        </button>
                                                        <button
                                                            className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 mt-2 rounded-full ml-1"
                                                            onClick={() => DeleteSubscription(subscription.netid)}
                                                        >
                                                            Delete
                                                        </button>
                                                        <button
                                                            className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 mt-2 rounded-full ml-1"
                                                            onClick={() => UpdateSubscription(subscription.netid)}
                                                        >
                                                            Edit
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                                <div className="flex justify-center mt-4">
                                    <ReactPaginate
                                        previousLabel={"Previous"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        pageCount={Math.ceil(filteredSubscriptions.length / itemsPerPage)}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        pageClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200 break-me"}
                                        breakLinkClassName={"page-link"}
                                        activeLinkClassName={"bg-blue-500 text-black"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NetworkTable;
